import selfiePrepMp4 from '../../../assets/video/selfie-prep.mp4?url';
import selfiePrepWebm from '../../../assets/video/selfie-prep.webm?url';
import selfiePrepPoster from '../../../assets/video/selfie-prep-poster.webp?url';
import {prefersReducedMotion} from '../../../utils/reducedMotion';
import {preloadImage} from '../documentCatalog/useDocumentVisualImage';

let isVideoRequested = false;

function preloadSelfieGuide() {
  void preloadImage(selfiePrepPoster);
  if (isVideoRequested || typeof document === 'undefined' || prefersReducedMotion())
    return;
  isVideoRequested = true;
  const canPlayWebm = Boolean(document.createElement('video').canPlayType('video/webm'));
  fetch(canPlayWebm ? selfiePrepWebm : selfiePrepMp4, {priority: 'low'}).catch(() => {
    isVideoRequested = false;
  });
}

export {preloadSelfieGuide, selfiePrepMp4, selfiePrepPoster, selfiePrepWebm};
